import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import Heading from '@starbucks-web/pattern-library/lib/components/heading';
import ImageLoader from '@starbucks-web/pattern-library/lib/components/image-loader';
import ContentColumn from '@starbucks-web/pattern-library/lib/components/content-column';

import { configImagesUrlSelector } from 'shared/app/state/selectors/config';

import styles from './styles.cssm';
import messages from './messages';

const howItWorksItems = [
  {
    image: 'earn-stars-2.svg',
    title: <FormattedMessage {...messages.earnStars} />,
    description: <FormattedMessage {...messages.earnStarsDescription} />,
  },
  {
    image: 'enjoy-rewards-2.svg',
    title: <FormattedMessage {...messages.getRewarded} />,
    description: <FormattedMessage {...messages.getRewardedDescription} />,
  },
  {
    image: 'indulge-benefits.svg',
    title: <FormattedMessage {...messages.indulgeBenefits} />,
    description: <FormattedMessage {...messages.indulgeBenefitsDescription} />,
  },
];

const HowItWorks = () => {
  const imageBaseUrl = useSelector(configImagesUrlSelector);
  return (
    <ContentColumn
      className={`${styles.container} color-greenOnPrimary bg-whiteSurfacePrimary1 sb-global-gutters`}
      innerClassName={`${styles.innerContainerSpacing} md-flex flex-column`}
    >
      <div className="flex flex-column items-center text-center">
        <Heading
          className={`${styles.headingText} text-bold`}
          size="xl"
          tagName="h2"
        >
          <FormattedMessage {...messages.header} />
        </Heading>
        <p className={`${styles.bodyText} color-textBodyOnPrimary text-xs mt4`}>
          <FormattedMessage {...messages.subheading} />
        </p>
      </div>
      <div className={`${styles.itemsContainer} flex mt5 px4`}>
        {howItWorksItems.map((item, index) => {
          const { title, description, image } = item;
          return (
            <div
              className="flex flex-auto flex-column items-center text-center px4 py3"
              key={`${title}-${index}`}
            >
              <ImageLoader
                role="presentation"
                src={`${imageBaseUrl}/sr6-rewards/${image}`}
                width="110"
              />
              <Heading className="text-bold mt2 mb2 lg-mt3" tagName="h3">
                {title}
              </Heading>
              <p className="text-xs">{description}</p>
            </div>
          );
        })}
      </div>
    </ContentColumn>
  );
};

export default HowItWorks;
